// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.selectTabs = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$html: $('html'),
			$selectTabs: $('.select-tabs'),
			$selectTabsContainer: $('.select-tabs-container'),
			selectTabsContainerContent: '.select-tabs-container__content',
			selectTabsContainerContentActive: 'select-tabs-container__content--active',
			$captcha: $('.scfCaptchaGeneralPanel table td input[type="image"]:first-of-type')
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);

			if (typeof store.get('captchaValue') !== 'undefined' && typeof store.get('captchaValue') !== 'null') {
				var $selectTabsContent = $('#' + store.get('captchaValue'));

				$selectTabsContent.slideDown("750", function() {
					$selectTabsContent.addClass(settings.selectTabsContainerContentActive);
					store.remove('captchaValue');
				});
			}
		};

		// Bind events
		methods.events = function() {

			// Captcha fix so form loads on refresh of captcha refresh
			settings.$captcha.on('click', function(event) {
				event.preventDefault();
				var $this = $(this),
					activeTab = $this.closest('.' + settings.selectTabsContainerContentActive).attr('id');
				store.set('captchaValue', activeTab);
			});

			// Mobile Search button click toggles the class
			settings.$selectTabs.off('change.lmGlobal').on('change.lmGlobal', function(event) {
				event.preventDefault();
				var $this = $(this);
				var $selectTabsContent = $('#' + $this.val());
				if($('.' + settings.selectTabsContainerContentActive).length){
					$('.' + settings.selectTabsContainerContentActive).slideUp("500", function() {
						$selectTabsContent.slideDown("750", function() {
							$('.' + settings.selectTabsContainerContentActive).removeClass(settings.selectTabsContainerContentActive);
 	 					$selectTabsContent.addClass(settings.selectTabsContainerContentActive);
					  });
				  });
				}
				else {
					$selectTabsContent.slideDown("750", function() {
						$selectTabsContent.addClass(settings.selectTabsContainerContentActive);
					});
				}
			});
		};

		// On load function.
		methods.initContext = function() {
			methods.setCurrentSettings();

			// NOTE: This is a hack and a proper solution will need to be found
			// Check for errors on page load
			$(settings.selectTabsContainerContent).each(function( index ) {
				var $this = $(this);
				if($this.find('.scfValidatorRequired').length){
					$this.slideDown("750", function() {
						$this.addClass(settings.selectTabsContainerContentActive);
					});
				}
			});

		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		// NOTE: Method you'd like initialized on a per context basis.
		methods.initContext($(this));

		// Run once methods when jquery plugin is called.
		methods.events(this);

	};

	if ($('.select-tabs').length) {
		$('.select-tabs').selectTabs();
	}

}(jQuery));
